import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.75 10.8165L7.46429 15.5832L19.25 3.6665",
		stroke: "black",
		strokeWidth: 2.75,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckMark;
